export const trimStringValues = <T>(value: T): T => {
  if (typeof value === 'string') {
    return value.trim() as T
  }

  if (Array.isArray(value)) {
    return value.map((item) => trimStringValues(item)) as T
  }

  if (!value || typeof value !== 'object') {
    return value
  }

  if (Object.getPrototypeOf(value) !== Object.prototype) {
    return value
  }

  return Object.fromEntries(
    Object.entries(value).map(([key, fieldValue]) => {
      return [key, trimStringValues(fieldValue)]
    })
  ) as T
}
